const mockVoiceContent = {
  from: '+18577609496',
  to: '+16263778366',
}

export default mockVoiceContent
